import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "block",
		width: "100%",
		minWidth: "100%",
		maxWidth: "100%",
		flex: "0 0 100%",
		alignSelf: "stretch",
		overflow: "hidden",
		boxSizing: "border-box",
	},
	loadingRoot: {
		display: "block",
		width: "100%",
		minWidth: "100%",
		maxWidth: "100%",
		flex: "0 0 100%",
		alignSelf: "stretch",
		overflow: "hidden",
		boxSizing: "border-box",
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2),
	},
	errorBox: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		padding: theme.spacing(2),
		background: "#F5F5F5",
		fontSize: "0.75rem",
		textAlign: "center",
	},
	retryButton: {
		marginTop: theme.spacing(2),
		textTransform: "none",
	},
	container: {
		minHeight: 200,
	},
}));

export default useStyles;
